import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { getGroupById } from "../api/group";
import logo from "../assets/oncommit.png";
import { useTimer } from "../hooks/useTimer";
import { updateTime } from "../redux/actions";
import { GAME_TIME_SECS, ROUTES } from "../utils/constants";
import {
	formatMinutes,
	formatSeconds,
	getTimer,
	updateStats,
	updateTimer,
	setLastTickNow,
	getLastTick,
	setLastTick 
} from "../utils/helpers";
import { modalIntro, modalText } from "../utils/logger";

export default function TopBar() {
	const timeout = GAME_TIME_SECS;
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const location = useLocation();
	const game = useSelector((state) => state.game);
	const [group, setGroup] = useState(useSelector((state) => state.group));
	//const [time, setTime] = useState(parseInt(group?.time));
	//let isACTIVE = false;
	const [score, setScore] = useState(group?.score || 0);

	const [time, setTime] = useState(() => {
		const saved = getTimer();
		const n = saved !== null ? Number(saved) : parseInt(group?.time || 0, 10);
		return Number.isFinite(n) ? n : 0;
	});

	/*
	useTimer(() => {
		if (!isACTIVE && getTimer()) isACTIVE = true;
		if (isACTIVE) handleTimer();
	}, 1000);
	*/
	useTimer(() => {
		handleTimer();
	}, 1000);

	/*
	const handleTimer = () => {
		if (!getTimer()) isACTIVE = false;
		else {
			setTime(time + 1);
			updateTimer(time);
		}
	};
	*/

	useEffect(() => {
	  if (getTimer() !== null && !getLastTick()) setLastTickNow();
	}, []);

	const handleTimer = () => {
		// Si no hay contador, no corremos
		if (getTimer() === null) return;
		const now = Date.now();
		const prevTick = getLastTick() ?? now;
		const deltaMs  = now - prevTick;
		const deltaSec = Math.floor(deltaMs / 1000);
		if (deltaSec <= 0) return;
		setTime((prev) => {
			const next = prev + deltaSec;
			updateTimer(next);
			setLastTick(prevTick + deltaSec * 1000);
			return next;
		});
	};

	useEffect(() => {
		const onVis = () => {
			if (document.visibilityState === "visible") {
			handleTimer(); // actualiza de golpe lo pasado en 2º plano
			}
		};
		document.addEventListener("visibilitychange", onVis);
		return () => document.removeEventListener("visibilitychange", onVis);
	}, []);

	useEffect(() => {
		if (
			time >= timeout &&
			group.lastVisited !== ROUTES.GAMEOVER &&
			!game?.demo
		) {
			dispatch(updateTime(time));
			updateStats({
				...group,
				time: time,
				lastVisited: ROUTES.GAMEOVER,
				finished: true,
			});
			navigate(ROUTES.GAMEOVER);
		} else if (group?.finished) {
			navigate(group?.lastVisited || ROUTES.RESULTS);
		}
	}, [time, group, game, navigate, dispatch]);

	useEffect(() => {
		if (group) {
			getGroupById(group?._id)
				.then((res) => {
					if (res.status === 200) {
						let group = res.data;
						let score = group?.score;
						setScore(score);
					}
				})
				.catch((error) => {});
		}
	}, [location]);

	const REFERENCIAS = `
	<div class="w-100 px-4" style="text-align: left;">
		<h3 class="txtTitulos bold">
			REFERENCIAS BIBLIOGRÁFICAS ONCOMMIT PATIENT ROOM
		</h3>
		<p class="txtTexto1">
			<ul>
				<li>Armstrong AJ, Azad AA, Iguchi T, et al. Improved Survival With Enzalutamide in Patients With Metastatic Hormone-Sensitive Prostate Cancer. J Clin Oncol. 2022 May 20;40(15):1616-22. https://doi.org/10.1200/JCO.22.00193</li>
				<li>Armstrong AJ, Szmulewitz RZ, Petrylak DP, et al. ARCHES: A Randomized, Phase III Study of Androgen Deprivation Therapy With Enzalutamide or Placebo in Men With Metastatic Hormone-Sensitive Prostate Cancer. J Clin Oncol. 2019 Nov 10;37(32):2974-86. https://doi.org/10.1200/JCO.19.00799</li>
				<li>Baccaglini W, Rodrigues AF, Teles SB, et al. The current role of local treatment in metastatic prostate cancer: systematic review and meta-analysis. Acta Oncol. 2022 Nov;61(11):1386-93.&nbsp;</li>
				<li>Banna GL, Basso U, Giunta EF, et al. The Geriatric G8 Score Is Associated with Survival Outcomes in Older Patients with Advanced Prostate Cancer in the ADHERE Prospective Study of the Meet-URO Network. Curr Oncol. 2022 Oct 14;29(10):7745-53. https://doi.org/10.3390/curroncol29100612.</li>
				<li>Bellera CA, Rainfray M, Mathoulin-P&eacute;lissier S, et al. Screening older cancer patients: first evaluation of the G-8 geriatric screening tool. Ann Oncol. 2012 Aug;23(8):2166-72. https://doi.org/10.1093/annonc/mdr587</li>
				<li>Burdett S, Boev&eacute; LM, Ingleby FC, et al.; STOPCAP M1 Radiotherapy Collaborators. Prostate Radiotherapy for Metastatic Hormone-sensitive Prostate Cancer: A STOPCAP Systematic Review and Meta-analysis. Eur Urol. 2019 Jul;76(1):115-24. https://doi.org/10.1016/j.eururo.2019.02.003</li>
				<li>Chi KN, Agarwal N, Bjartell A, et al.; TITAN Investigators. Apalutamide for Metastatic, Castration-Sensitive Prostate Cancer. N Engl J Med. 2019 Jul 4;381(1):13-24. https://doi.org/10.1056/NEJMoa1903307</li>
				<li>Chi KN, Chowdhury S, Bjartell A, et al. Apalutamide in Patients With Metastatic Castration-Sensitive Prostate Cancer: Final Survival Analysis of the Randomized, Double-Blind, Phase III TITAN Study. J Clin Oncol. 2021 Jul 10;39(20):2294-303. https://doi.org/10.1200/JCO.20.03488</li>
				<li>Chi KN, Chowdhury S, Bjartell A, et al. Apalutamide in Patients With Metastatic Castration-Sensitive Prostate Cancer: Final Survival Analysis of the Randomized, Double-Blind, Phase III TITAN Study. J Clin Oncol. 2021 Jul 10;39(20):2294-303. https://doi.org/10.1200/JCO.20.03488-URO Network.</li>
				<li>Chowdhury S, Bjartell A, Agarwal N, et al. Deep, rapid, and durable prostate-specific antigen decline with apalutamide plus androgen deprivation therapy is associated with longer survival and improved clinical outcomes in TITAN patients with metastatic castration-sensitive prostate cancer. Ann Oncol. 2023 May;34(5):477-85. https://doi.org/10.1016/j.annonc.2023.02.009</li>
				<li>Darolutamide in Addition to ADT Versus ADT in Metastatic Hormone-sensitive Prostate Cancer (ARANOTE) [Internet]. ClinicalTrials.gov identifier: NCT04736199 [consulta en enero de 2022]. Disponible en: https://clinicaltrials.gov/ct2/show/NCT04736199.</li>
				<li>Darolutamide in Addition to Standard Androgen Deprivation Therapy and Docetaxel in Metastatic Hormone-Sensitive Prostate Cancer (ARASENS) [Internet]. ClinicalTrials.gov identifier: NCT0279960 [consulta en enero de 2022]. Disponible en: https://clinicaltrials.gov/ct2/show/NCT02799602.&nbsp;</li>
				<li>Fendler WP, Weber M, Iravani A, et al. Prostate-Specific Membrane Antigen Ligand Positron Emission Tomography in Men with Nonmetastatic Castration-Resistant Prostate Cancer. Clin Cancer Res. 2019 Dec 15;25(24):7448-54. https://doi-org.pbidi.unam.mx:2443/10.1158/1078-0432.CCR-19-1050</li>
				<li>Fizazi K, Foulon S, Carles J, et al.; PEACE-1 investigators. Abiraterone plus prednisone added to androgen deprivation therapy and docetaxel in de novo metastatic castration-sensitive prostate cancer (PEACE-1): a multicentre, open-label, randomised, phase 3 study with a 2&thinsp;&times;&thinsp;2 factorial design. Lancet. 2022 Apr 30;399(10336):1695-707. https://doi.org/10.1016/S0140-6736(22)00367-1</li>
				<li>Fizazi K, Galceran JC, Foulon S, et al. LBA5 A phase III trial with a 2&times;2 factorial design in men with de novo metastatic castration-sensitive prostate cancer: Overall survival with abiraterone acetate plus prednisone in PEACE-1. Ann Oncol. 2021;32(Suppl 5):S1299. https://doi.org/10.1016/j.annonc.2021.08.2099</li>
				<li>Fizazi K, Tran N, Fein L, et al. Abiraterone acetate plus prednisone in patients with newly diagnosed high-risk metastatic castration-sensitive prostate cancer (LATITUDE): final overall survival analysis of a randomised, double-blind, phase 3 trial. Lancet Oncol. 2019 May;20(5):686-700. https://doi.org/10.1016/S1470-2045(19)30082-8</li>
				<li>Fizazi K, Tran N, Fein L, et al.; LATITUDE Investigators. Abiraterone plus Prednisone in Metastatic, Castration-Sensitive Prostate Cancer. N Engl J Med. 2017 Jul 27;377(4):352-60. https://doi.org/10.1056/NEJMoa1704174</li>
				<li>Francini E, Gray KP, Xie W, et al. Time of metastatic disease presentation and volume of disease are prognostic for metastatic hormone sensitive prostate cancer (mHSPC). Prostate. 2018 Sep;78(12):889-95. https://doi.org/10.1002/pros.23645</li>
				<li>Hoyle AP, Ali A, James ND, et al.; STAMPEDE Investigators. Abiraterone in &quot;High-&quot; and &quot;Low-risk&quot; Metastatic Hormone-sensitive Prostate Cancer. Eur Urol. 2019 Dec;76(6):719-28. https://doi.org/10.1016/j.eururo.2019.08.006</li>
				<li>James ND, Sydes MR, Clarke NW, et al.; STAMPEDE investigators. Addition of docetaxel, zoledronic acid, or both to first-line long-term hormone therapy in prostate cancer (STAMPEDE): survival results from an adaptive, multiarm, multistage, platform randomised controlled trial. Lancet. 2016 Mar 19;387(10024):1163-77. https://doi.org/10.1016/S0140-6736(15)01037-5</li>
				<li>Kyriakopoulos CE, Chen YH, Carducci MA, et al. Chemohormonal Therapy in Metastatic Hormone-Sensitive Prostate Cancer: Long-Term Survival Analysis of the Randomized Phase III E3805 CHAARTED Trial. J Clin Oncol. 2018 Apr 10;36(11):1080-7. https://doi.org/10.1200/JCO.2017.75.3657</li>
				<li>Merseburger AS, Agarwal N, Bhaumik A, et al. Apalutamide plus androgen deprivation therapy in clinical subgroups of patients with metastatic castration-sensitive prostate cancer: A subgroup analysis of the randomised clinical TITAN study. Eur J Cancer. 2023 Nov;193:113290. https://doi.org/10.1016/j.ejca.2023.113290</li>
				<li>Multisystem failure regarding frailty necessitates multisystem intervention [Internet]. Johns Hopkins Medicine [consulta el 8 de marzo de 2012]. Disponible en: https://www.hopkinsmedicine.org/news/newsroom/news-releases/2021/03/multisystem-failure-regarding-frailty-necessitates-multisystem-intervention</li>
				<li>Nasser NJ, Sun K, Scanlon KM, Mishra MV, Molitoris JK. Administering Docetaxel for Metastatic Hormone-Sensitive Prostate Cancer 1-6 Days Compared to More Than 14 Days after the Start of LHRH Agonist Is Associated with Better Clinical Outcomes Due to Androgen Flare. Cancers (Basel). 2022 Feb 9;14(4):864. https://doi.org/10.3390/cancers14040864</li>
				<li>National Comprehensive Cancer Network. Prostate cancer. NCCN clinical practice guidelines in oncology. J Natl Compr Canc Netw. 2004 May;2(3):224-48. https://doi.org/10.6004/jnccn.2004.0021</li>
				<li>Shpilsky J, Stevens J, Bubley G. An up-to-date evaluation of abiraterone for the treatment of prostate cancer. Expert Opin Pharmacother. 2021 Jul;22(10):1227-34. https://doi.org/10.1080/14656566.2021.1915287</li>
				<li>Smith MR, Hussain M, Saad F, et al.; ARASENS Trial Investigators. Darolutamide and Survival in Metastatic, Hormone-Sensitive Prostate Cancer. N Engl J Med. 2022 Mar 24;386(12):1132-1142. https://doi.org/10.1056/NEJMoa2119115</li>
				<li>Smith MR, Saad F, Chowdhury S, et al. Apalutamide and Overall Survival in Prostate Cancer. Eur Urol. 2021 Jan;79(1):150-8. https://doi.org/10.1016/j.eururo.2020.08.011</li>
				<li>Sweeney C, Martin AJ, Zielinski RR, et al Overall survival (OS) results of a phase III randomized trial of standard-of-care therapy with or without enzalutamide for metastatic hormone-sensitive prostate cancer (mHSPC): ENZAMET (ANZUP 1304), an ANZUP-led international cooperative group trial. J Clin Oncol. 2019;37(18). doi:10.1200/JCO.2019.37.18_suppl.LBA2</li>
				<li>Sweeney CJ, Chen YH, Carducci M, et al. Chemohormonal Therapy in Metastatic Hormone-Sensitive Prostate Cancer. N Engl J Med. 2015 Aug 20;373(8):737-46. https://doi.org/10.1056/NEJMoa1503747</li>
				<li>Zacho HD, Ravn S, Afshar-Oromieh A, Fledelius J, Ejlersen JA, Petersen LJ. Added value of 68Ga-PSMA PET/CT for the detection of bone metastases in patients with newly diagnosed prostate cancer and a previous <sup>99</sup>mTc bone scintigraphy. EJNMMI Res. 2020 Apr 8;10(1):31. https://doi-org.pbidi.unam.mx:2443/10.1186/s13550-020-00618-0</li>
				<li>Zhao G, Ji B. Head-To-Head Comparison of <sup>68</sup>Ga-PSMA-11 PET/CT and <sup>99m</sup>Tc-MDP Bone Scintigraphy for the Detection of Bone Metastases in Patients With Prostate Cancer: A Meta-Analysis. AJR Am J Roentgenol. 2022 Sep;219(3):386-95. doi: 10.2214/AJR.21.27323. https://doi-org.pbidi.unam.mx:2443/10.2214/AJR.21.27323</li>
			</ul>
		</p>
	</div>
	`;

	return (
		<div className="py-2">
		<div className="row d-flex justify-content-between align-items-center legalGebro px-4">
			{/* Logo */}
			<div className="col-4 d-flex justify-content-start txtTexto2 txtRed">
				<span>{group?.fullName || "NOMBRE DEL EQUIPO"}</span>
				<span
					className="px-2 ms-3 rounded"
					style={{
						border: "1px #b1000d dashed",
						borderRadius: "12px",
						minWidth: "60px",
						fontSize: "16px",
						fontWeight: "bold",
						color: "#b1000d"
					}}
				>equipo nº{group?.tableNum || 0}
				</span>
			</div>

			{/* Marcador de puntos */}
			<div className="col-4 d-flex align-items-center justify-content-center">
				<div
					className="d-flex flex-column align-items-center justify-content-center px-4 py-2 rounded shadow-sm"
					style={{
					backgroundColor: "#b1000d",
					borderRadius: "12px",
					minWidth: "140px",
					}}
				>
					<div className="txt42 bold" style={{ color: "white" }}>
					{score}
					</div>
			</div>
			</div>

			{/* Botones + timer */}
			<div className="col-4 d-flex align-items-center justify-content-end">
				<div
				className="roundBtn mx-2"
				onClick={() => {
					modalText({
					html: REFERENCIAS,
					});
				}}
				>
				Bibliografía
				</div>
				<div
				className="roundBtn mx-2 d-flex align-items-center justify-content-center pb-1"
				onClick={() => {
					modalIntro();
				}}
				>
				Instrucciones
				</div>
				<div className="mx-2"></div>
				<div className="timer title1">
				{formatMinutes(time, timeout, group?.finished)}
				</div>
				<div className="title1 px-1 pt-1 blink bold">:</div>
				<div className="timer title1">
				{formatSeconds(time, timeout, group?.finished)}
				</div>
			</div>
			</div>
		</div>
		);

}
